<template>
  <div class="system-manage-container">
    <!-- 页面标题 -->
    <div class="page-header">
      <h1>系统管理</h1>
      <div class="update-time">最后更新: {{ updateTime }}</div>
    </div>

    <!-- 敏感内容检测卡片 -->
    <div class="config-cards">
      <div class="config-card">
        <div class="card-header">
          <div class="header-left">
            <div class="card-icon">
              <i class="el-icon-shield"></i>
            </div>
            <div class="card-info">
              <h3>敏感内容检测</h3>
              <p class="card-description">
                控制敏感内容检测功能的开启/关闭状态，修改后立即生效，无需重启服务
              </p>
            </div>
          </div>
          <div class="header-right">
            <el-switch
              v-model="sensitiveCheckEnabled"
              :loading="switching"
              :disabled="switching"
              @change="handleToggle"
              active-color="#67C23A"
              inactive-color="#F56C6C"
              active-text="已开启"
              inactive-text="已关闭"
              style="--el-switch-on-color: #67C23A; --el-switch-off-color: #F56C6C"
            >
            </el-switch>
          </div>
        </div>

        <div class="card-body">
          <div class="status-info">
            <div class="status-item">
              <span class="status-label">当前状态:</span>
              <span
                class="status-value"
                :class="sensitiveCheckEnabled ? 'status-on' : 'status-off'"
              >
                {{ sensitiveCheckEnabled ? "🟢 已开启" : "🔴 已关闭" }}
              </span>
            </div>
            <div class="status-item">
              <span class="status-label">状态说明:</span>
              <span class="status-value">
                {{ statusDescription }}
              </span>
            </div>
          </div>

          
        </div>
      </div>

    
    </div>

  </div>
</template>

<script>
import { system } from "../../../api/index";

export default {
  name: "SystemManage",
  data() {
    return {
      loading: false,
      switching: false,
      sensitiveCheckEnabled: false,
      statusDescription: "",
      updateTime: "",
      operationLogs: [],
    };
  },
  mounted() {
    this.updateCurrentTime();
    this.loadSensitiveCheckStatus();
    // 每30秒更新一次时间
    setInterval(this.updateCurrentTime, 30000);
  },
  methods: {
    // 更新当前时间
    updateCurrentTime() {
      const now = new Date();
      this.updateTime = now.toLocaleString("zh-CN", {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    },

    // 加载敏感检测状态
    async loadSensitiveCheckStatus() {
      this.loading = true;
      try {
        const response = await system.getSensitiveCheckStatus();
        if (response.code === 200) {
          this.sensitiveCheckEnabled = response.data.enabled;
          this.statusDescription =
            response.data.description || this.getStatusDescription();
          this.updateCurrentTime();
        } else {
          this.$message.error(response.msg || "获取状态失败");
        }
      } catch (error) {
        console.error("获取敏感检测状态失败:", error);
        this.$message.error("获取状态失败，请重试");
      } finally {
        this.loading = false;
      }
    },

    // 切换敏感检测开关
    async handleToggle(value) {
      this.switching = true;
      const action = value ? "开启" : "关闭";

      try {
        const response = await system.toggleSensitiveCheck();
        if (response.code === 200) {
          this.sensitiveCheckEnabled = response.data.enabled;
          this.statusDescription =
            response.data.message || this.getStatusDescription();

          // 添加操作日志
          this.addOperationLog(
            `${action}敏感内容检测成功 - ${this.statusDescription}`
          );

          this.$message.success({
            message: response.data.message || `敏感内容检测已${action}`,
            duration: 3000,
          });

          this.updateCurrentTime();
        } else {
          // 操作失败，恢复开关状态
          this.sensitiveCheckEnabled = !value;
          this.$message.error(response.msg || `${action}失败`);
        }
      } catch (error) {
        console.error("切换敏感检测状态失败:", error);
        // 操作失败，恢复开关状态
        this.sensitiveCheckEnabled = !value;
        this.$message.error(`${action}失败，请重试`);
      } finally {
        this.switching = false;
      }
    },

    // 刷新状态
    async refreshStatus() {
      await this.loadSensitiveCheckStatus();
      this.$message.success("状态已刷新");
    },

    // 获取状态描述
    getStatusDescription() {
      return this.sensitiveCheckEnabled
        ? "敏感内容检测已开启，系统会自动检测用户输入内容"
        : "敏感内容检测已关闭，系统将跳过内容检测流程";
    },

    // 添加操作日志
    addOperationLog(content) {
      const now = new Date();
      const timeStr = now.toLocaleString("zh-CN", {
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });

      this.operationLogs.unshift({
        time: timeStr,
        content: content,
      });

      // 只保留最近10条日志
      if (this.operationLogs.length > 10) {
        this.operationLogs = this.operationLogs.slice(0, 10);
      }
    },
  },
};
</script>

<style scoped>
.system-manage-container {
  background: #faf9de;
  min-height: 100%;
  padding: 20px;
  font-family: "fangzheng", sans-serif;
  overflow-y: auto;
}

/* 页面标题 */
.page-header {
  margin-bottom: 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  padding: 20px 24px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.page-header h1 {
  margin: 0;
  color: #000;
  font-size: 24px;
  font-weight: bold;
}

.update-time {
  color: #666;
  font-size: 14px;
}

/* 配置卡片区域 */
.config-cards {
  display: grid;
  gap: 20px;
  margin-bottom: 24px;
}

.config-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.3s ease;
}

.config-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

/* 卡片头部 */
.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 24px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 2px solid #f0f0f0;
  gap: 20px;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.card-icon {
  width: 60px;
  height: 60px;
  border-radius: 12px;
  background: linear-gradient(135deg, #ffd700, #ffed4a);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  color: #000;
  flex-shrink: 0;
}

.card-info {
  flex: 1;
}

.card-info h3 {
  margin: 0 0 8px 0;
  font-size: 20px;
  font-weight: bold;
  color: #000;
}

.card-description {
  margin: 0;
  font-size: 14px;
  color: #666;
  line-height: 1.5;
}

.header-right {
  flex-shrink: 0;
}

/* 卡片主体 */
.card-body {
  padding: 24px;
}

.status-info {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.status-item {
  display: flex;
  align-items: center;
  padding: 8px 0;
  gap: 12px;
}

.status-item:not(:last-child) {
  border-bottom: 1px solid #e0e0e0;
}

.status-label {
  font-weight: bold;
  color: #333;
  min-width: 100px;
}

.status-value {
  color: #666;
  flex: 1;
}

.status-value.status-on {
  color: #67c23a;
  font-weight: bold;
}

.status-value.status-off {
  color: #f56c6c;
  font-weight: bold;
}

/* 功能列表 */
.feature-list {
  margin-top: 20px;
}

.feature-list h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.feature-list ul {
  margin: 0;
  padding: 0;
  list-style: none;
}

.feature-list li {
  padding: 8px 0;
  color: #666;
  display: flex;
  align-items: center;
  gap: 8px;
}

.feature-list li i {
  color: #67c23a;
  font-weight: bold;
}

/* 操作日志卡片 */
.log-card {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.log-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 24px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 2px solid #f0f0f0;
}

.log-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #000;
  display: flex;
  align-items: center;
  gap: 8px;
}

.log-body {
  padding: 20px 24px;
  max-height: 300px;
  overflow-y: auto;
}

.empty-log {
  text-align: center;
  padding: 40px 20px;
  color: #999;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.empty-log i {
  font-size: 48px;
  color: #ddd;
}

.log-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.log-item {
  padding: 12px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 3px solid #ffd700;
}

.log-time {
  font-size: 12px;
  color: #999;
  margin-bottom: 4px;
}

.log-content {
  font-size: 14px;
  color: #333;
}

/* 使用说明 */
.usage-guide {
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.guide-header {
  padding: 20px 24px;
  background: linear-gradient(135deg, #f8f9fa, #ffffff);
  border-bottom: 2px solid #f0f0f0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.guide-header i {
  font-size: 24px;
  color: #ffd700;
}

.guide-header h3 {
  margin: 0;
  font-size: 18px;
  font-weight: bold;
  color: #000;
}

.guide-content {
  padding: 24px;
}

.guide-section {
  margin-bottom: 20px;
}

.guide-section:last-child {
  margin-bottom: 0;
}

.guide-section h4 {
  margin: 0 0 12px 0;
  font-size: 16px;
  font-weight: bold;
  color: #000;
}

.guide-section p {
  margin: 0;
  color: #666;
  line-height: 1.6;
}

.guide-section ul {
  margin: 8px 0 0 0;
  padding-left: 20px;
  color: #666;
  line-height: 1.8;
}

.guide-section strong {
  color: #000;
  font-weight: bold;
}

/* 滚动条样式 */
.log-body::-webkit-scrollbar {
  width: 6px;
}

.log-body::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.log-body::-webkit-scrollbar-thumb {
  background: #ffd700;
  border-radius: 10px;
}

.log-body::-webkit-scrollbar-thumb:hover {
  background: #ffed4a;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .system-manage-container {
    padding: 16px;
  }

  .page-header {
    flex-direction: column;
    gap: 12px;
    text-align: center;
  }

  .card-header {
    flex-direction: column;
    align-items: stretch;
  }

  .header-left {
    flex-direction: column;
    text-align: center;
  }

  .status-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .log-header {
    flex-direction: column;
    gap: 12px;
  }
}
</style>
